import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2049ParamStatus: 'idle',
    startProcess2049ParamError: undefined as any,
    loadUserParamsProcess2049ParamStatus: 'idle',
    loadUserParamsProcess2049ParamError: undefined as any,

    process2049ParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2049Param = createAsyncThunk('process2049ParamSlice/startProcess2049Param', async ({ process2049Param }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2049Param/`,
        prepareData(process2049Param),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2049ParamStatus } = getState().process2049ParamSlice
        return startProcess2049ParamStatus !== 'pending'
    }
})

export const loadUserParamsProcess2049Param = createAsyncThunk('process2049ParamSlice/loadUserParamsProcess2049Param', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2049Param/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2049ParamStatus } = getState().process2049ParamSlice
        return loadUserParamsProcess2049ParamStatus !== 'pending'
    }
})

const Process2049ParamSlice = createSlice({
    name: 'process2049ParamSlice',
    initialState,
    reducers: {
        resetstartProcess2049Param: (state) => {
            state.job = undefined
            state.startProcess2049ParamError = undefined
        },
        resetstartProcess2049ParamError: (state) => {
            state.startProcess2049ParamError = undefined
        },
        resetloadUserParamsProcess2049Param: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2049ParamError = undefined
        },
        resetloadUserParamsProcess2049ParamError: (state) => {
            state.loadUserParamsProcess2049ParamError = undefined
        },
        removeFromProcess2049ParamListById: (state, action) => {
            state.process2049ParamList = state.process2049ParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2049ParamListByIds: (state, action) => {
            state.process2049ParamList = state.process2049ParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2049ParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2049ParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2049ParamList = []
            state.startProcess2049ParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2049Param.pending, (state) => {
            state.startProcess2049ParamStatus = 'pending'
            state.startProcess2049ParamError = undefined
        })
        builder.addCase(startProcess2049Param.fulfilled, (state, action) => {
            state.startProcess2049ParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2049Param.rejected, (state, action) => {
            state.startProcess2049ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2049ParamError = action.error.message
            } else {
                state.startProcess2049ParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2049Param.pending, (state) => {
            state.loadUserParamsProcess2049ParamStatus = 'pending'
            state.loadUserParamsProcess2049ParamError = undefined
        })
        builder.addCase(loadUserParamsProcess2049Param.fulfilled, (state, action) => {
            state.loadUserParamsProcess2049ParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2049Param.rejected, (state, action) => {
            state.loadUserParamsProcess2049ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2049ParamError = action.error.message
            } else {
                state.loadUserParamsProcess2049ParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2049Param,
    resetstartProcess2049ParamError,
    resetloadUserParamsProcess2049Param,
    resetloadUserParamsProcess2049ParamError,
    removeFromProcess2049ParamListById,
    removeFromProcess2049ParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2049ParamSlice.actions
export default Process2049ParamSlice.reducer
